import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-close\">\n<path d=\"M156.6,33.3l10.1,10.1L110.4,100l56.3,56.6l-10.1,10.1l-56.3-56.5L44,166.6l-10.1-10.1L90.2,100L33.9,43.4L44,33.3\n\tl56.3,56.5L156.6,33.3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol